import api from '../../../services/api';

/**
 * „Transporty” of the ZK card (forecast by delivery, owner 2026-10-16,
 * docs/decisions/2026-10-16-prognoza-wedlug-dostaw.md). Backend:
 * services/orderDeliveryScheduleService.js — trucks with this order's cargo,
 * „Spodziewana data dostarczenia”, no carrier or cost. `forecastMonth` /
 * `unassignedForecastMonth` come only for forecast readers (ADMIN); absent
 * means hidden, not „no month”.
 */
export interface OrderDeliveryScheduleLine {
  orderProductId: string | null;
  productName: string;
  quantity: number | null;
  unit: string | null;
  deliveredQuantity?: number | null;
}

export interface OrderDeliveryScheduleTransport {
  id: string;
  displayLabel: string | null;
  routeNumber: string | null;
  direction: string | null;
  customerOrderCount: number;
  supplierOrderCount: number;
  status: string;
  loadingDate: string | null;
  estimatedDelivery: string | null;
  actualDelivery: string | null;
  /** Linked without cargo rows (older data): carries the whole order. */
  wholeOrder: boolean;
  lines: OrderDeliveryScheduleLine[];
  forecastMonth?: string | null;
}

export interface OrderDeliverySchedule {
  orderId: string;
  canEditExpectedDelivery: boolean;
  unassignedForecastMonth?: string | null;
  transports: OrderDeliveryScheduleTransport[];
  /** What no truck carries yet: stays in the ZK „Miesiąc prognozy”. */
  unassigned: OrderDeliveryScheduleLine[];
}

export async function fetchOrderDeliverySchedule(orderId: string): Promise<OrderDeliverySchedule> {
  const response = await api.get(`/orders/${encodeURIComponent(orderId)}/delivery-schedule`);
  return response.data;
}

/** `estimatedDelivery` 'YYYY-MM-DD'; null falls back to the loading date (truck form rule). */
export async function updateOrderExpectedDelivery(
  orderId: string,
  transportId: string,
  estimatedDelivery: string | null,
): Promise<OrderDeliverySchedule> {
  const response = await api.patch(
    `/orders/${encodeURIComponent(orderId)}/delivery-schedule/${encodeURIComponent(transportId)}`,
    { estimatedDelivery },
  );
  return response.data;
}
